import { render, staticRenderFns } from "./SecretaryEdit.vue?vue&type=template&id=6778532c&scoped=true&"
import script from "./SecretaryEdit.vue?vue&type=script&lang=js&"
export * from "./SecretaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778532c",
  null
  
)

export default component.exports